<template>
  <div class="ui-space-part -table-">
    <div class="ui-space-table">
      <div class="ui-space-table__container">
        <div class="ui-space-table__head">
          <div
            class="ui-space-table__row -nav-"
            :style="{ 'grid-template-columns': gridLayout }"
          >
            <slot name="nav">
              <div
                v-for="title in navTitles"
                :key="title.id"
                class="ui-space-table__col"
                :class="title.selector && `-${title.selector}-`"
              >
                <div class="ui-space-table__col-container">
                  <p class="ui-space-table__title">
                    {{ title.title }}
                  </p>
                </div>
              </div>
            </slot>
          </div>
        </div>
        <div class="ui-space-table__body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultWidth: {
      type: String,
      default: '60px'
    },
    navTitles: {}
  },
  computed: {
    gridLayout() {
      const result = [];

      this.navTitles.forEach(prop => {
        if (prop) {
          result.push(prop.width || this.defaultWidth);
        }
      });

      return result.join(' ');
    }
  },
  methods: {
    navClick(id) {
      this.$emit('navClick', id);
    }
  }
};
</script>
